export const CNIL = 'CNIL';
export const EMAIL_OPTIN = 'EMAIL_OPTIN';
export const SMS_OPTIN = 'SMS_OPTIN';
export const MAIL_OPTIN = 'MAIL_OPTIN';
export const CGV = 'CGV';
export const IDENTITY_NUMBER = 'IDENTITY_NUMBER';
export const PHONE_OPTIN = 'PHONE_OPTIN';
export const PROFILING = 'PROFILING';
export const FOSUN_PARTNERS = 'FOSUN_PARTNERS';
export const CLUBMED_PLUS = 'CLUBMED_PLUS';
export const THEO = 'WEBTHEO';
export const PASSPORT = 'PASSPORT';
export const IDCARD = 'IDCARD';
// right now we only manage these two document types
export const DOCUMENT_TYPES = [PASSPORT, IDCARD];
